module.exports = __webpack_public_path__ + "media/images/building-68809c19532ed8e41831ad49f63a3d47.jpg";